import { Component, Input, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import { TypeMontantFourchette2 } from '../models/TypeMontantFourchette2';
import { Step3 } from '../../../../shared/models/component-messages/simp_in/step3';
import {CTRL_9201} from "../../../validators/9201/ctrl9201";
import {CTRL_496} from "../../../validators/496/ctrl496";
import {CTRL_495} from "../../../validators/495/ctrl495";
import {CTRL_494} from "../../../validators/494/ctrl494";
import {SimpANControlNames} from "../../annulation/simpANControleNames";
import {SimpINControlNames} from "../simpINControleNames";
@Component({
  selector: 'app-type-montant-fourchette',
  templateUrl: './type-montant-fourchette.component.html'
})
export class TypeMontantFourchetteComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeMontantFourchette2'
  @Input() parentForm: FormGroup;
  @Input() valeurEstimee : TypeMontantFourchette2;
  @Input() disabled: boolean;
  public step3 = new Step3();
  public rg1 = CTRL_494.id + '_1';
  public rg2 = CTRL_495.id + '_1';
  public rg3 = CTRL_496.id + '_1';

  constructor() { }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: SimpINControlNames.getCtrl_494Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: SimpINControlNames.getCtrl_495Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: SimpINControlNames.getCtrl_496Names_json() }));
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

}

